module.exports = __webpack_public_path__ + "media/click.0bc53d4f.mp3";